import React, { useEffect } from "react";
import { Modal, Form, Select, DatePicker, Checkbox, Button } from "antd";
import { useGlobalContext } from "../../../context/GlobalContext";
import useGet from "../../common/useGet";
import {
  API_FLOAT_INTEREST,
  API_FLOAT_INTEREST_STATEMENT_PROCESS,
} from "../../../utils/apis";
import useSet from "../../common/useSet";
import toast from "react-hot-toast";
import { PrimaryActionBtn } from "../../../components/layouts/RegisterLayoutHandler";

const FloatInterestStatementModal = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openInterestStatement } = globalData || {};
  const { loadData, loading, data: configs } = useGet();
  const {
    uploadData,
    submitting,
    error: submitError,
    success: submitSuccess,
  } = useSet();
  const [form] = Form.useForm();

  useEffect(() => {
    if (openInterestStatement) {
      loadData({ api: API_FLOAT_INTEREST });
    }
  }, [openInterestStatement]);

  const handleClose = () => {
    updateData({ openInterestStatement: false });
    form.resetFields();
  };

  const handleSubmit = (values: any) => {
    const payload = {
      config_id: values.config_id,
      period_start: values.period_start.format("YYYY-MM-DD"),
      period_end: values.period_end.format("YYYY-MM-DD"),
      post_to_ledger: values.post_to_ledger || false,
    };

    uploadData({
      api: API_FLOAT_INTEREST_STATEMENT_PROCESS,
      params: payload,
    });
  };

  useEffect(() => {
    if (submitSuccess) {
      toast.success("Float interest statement processed successfully");
      handleClose();
    }
  }, [submitSuccess]);

  useEffect(() => {
    if (
      submitError &&
      Object.keys(submitError).length > 0 &&
      !submitError.notSubmit
    ) {
      const errorMessage =
        (typeof submitError?.message === "string"
          ? submitError.message
          : null) ||
        (typeof submitError?.detail === "string" ? submitError.detail : null) ||
        "Failed to process float interest statement";
      toast.error(errorMessage);
    }
  }, [submitError]);

  const configOptions =
    configs?.results?.map((config: any) => ({
      label: config.name,
      value: config.id,
    })) || [];

  return (
    <Modal
      open={!!openInterestStatement}
      onCancel={handleClose}
      title="Float Interest Statement"
      footer={null}
      centered
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
        initialValues={{
          post_to_ledger: true,
        }}
      >
        <Form.Item
          label="Configuration"
          name="config_id"
          rules={[{ required: true, message: "Please select a configuration" }]}
        >
          <Select
            placeholder="Select configuration"
            loading={loading}
            options={configOptions}
          />
        </Form.Item>

        <Form.Item
          label="Period Start"
          name="period_start"
          rules={[{ required: true, message: "Please select period start" }]}
        >
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
        </Form.Item>

        <Form.Item
          label="Period End"
          name="period_end"
          rules={[{ required: true, message: "Please select period end" }]}
        >
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
        </Form.Item>

        <Form.Item name="post_to_ledger" valuePropName="checked">
          <Checkbox>Post to Ledger</Checkbox>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
            <Button onClick={handleClose} size="middle">
              Cancel
            </Button>
            <PrimaryActionBtn
              type="primary"
              htmlType="submit"
              loading={submitting}
              size="large"
            >
              Process Statement
            </PrimaryActionBtn>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FloatInterestStatementModal;
